import { createFileRoute } from '@tanstack/react-router'
import { HealthPlans } from 'pages/healthPlans/HealthPlans'
import { healthPlansSearchParamsSchema } from 'routes/health-plans/-searchParams'

function HealthPlansRouteComponent() {
  const { orgId, siteId } = Route.useSearch()

  return <HealthPlans organizationId={orgId} siteId={siteId} />
}

export const Route = createFileRoute('/health-plans/')({
  component: HealthPlansRouteComponent,
  staticData: {
    title: 'Health Plans',
    layout: {
      enableScrolling: true,
    },
  },
  validateSearch: healthPlansSearchParamsSchema,
})
